import { MagritteNotificationName } from 'utils/constants/notification';

enum Restrictions {
    DurationMin = 5,
    DurationMax = 60,
    ResolutionMin = 360,
    ResolutionMax = 3840,
}

export interface ValidateVideo {
    isValidate: boolean;
    meta: {
        width: number;
        height: number;
    };
    errors: Array<MagritteNotificationName>;
}

export const validateVideo = (file: Blob): Promise<ValidateVideo> => {
    let objectUrl: string;
    return new Promise<ValidateVideo>((resolve) => {
        const video = document.createElement('video');
        objectUrl = URL.createObjectURL(file);
        video.src = objectUrl;

        const errors: Array<MagritteNotificationName> = [];

        video.addEventListener('loadedmetadata', () => {
            const duration = video.duration;
            const width = video.videoWidth;
            const height = video.videoHeight;

            const isValidateByDuration = duration <= Restrictions.DurationMax && duration >= Restrictions.DurationMin;
            const isValidateByResolution =
                height >= Restrictions.ResolutionMin &&
                height <= Restrictions.ResolutionMax &&
                width >= Restrictions.ResolutionMin &&
                width <= Restrictions.ResolutionMax;

            if (!isValidateByDuration) {
                errors.push(
                    duration > Restrictions.DurationMax
                        ? MagritteNotificationName.CampaignFormVideoTooLongDuration
                        : MagritteNotificationName.CampaignFormVideoTooShortDuration
                );
            }
            if (!isValidateByResolution) {
                errors.push(MagritteNotificationName.CampaignFormVideoWrongResolution);
            }

            resolve({
                isValidate: !errors.length,
                meta: {
                    width,
                    height,
                },
                errors,
            });
        });

        video.addEventListener('error', () => {
            resolve({
                isValidate: false,
                meta: {
                    width: 0,
                    height: 0,
                },
                errors: [MagritteNotificationName.CampaignFormVideoErrorWhileProcess],
            });
        });
    }).finally(() => {
        if (objectUrl) {
            URL.revokeObjectURL(objectUrl);
        }
    });
};
